<template>
  <div class="groupMain">
    <div class="title">{{ title }}</div>
    <div class="groupCar">
      <!-- 样式一 -->
      <template v-if="styleOne">
        <div class="groupList" v-for="(item, index) in listOne" :key="index" @click="adRoute(item)">
          <div class="Deposit">
            <span>拍卖</span>
          </div>
          <div v-if="item.id" class="group-info">
            <!-- 标题 -->
            <div class="name-wrap">
              <div class="groupName">
                {{ item.name }}
              </div>
              <!-- sku -->
              <div
                class="goods-sku"
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityItemDtoList &&
                    item.activityItemInfoDto.activityItemDtoList[0] &&
                    item.activityItemInfoDto.activityItemDtoList[0].itemExtDto &&
                    item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes &&
                    item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes.length
                "
              >
                <div
                  class="goods-sku-item"
                  v-for="(attr, attrIndex) in item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes"
                  :key="attrIndex"
                >
                  {{ attr.attrVal }}
                </div>
              </div>
            </div>
            <!-- 降价拍活动开始时间 -->
            <div
              class="activity-time"
              v-if="
                item.activityItemInfoDto &&
                  item.activityItemInfoDto.auctionDto &&
                  item.activityItemInfoDto.auctionDto.reducePriceAuction
              "
            >
              <p
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityInfoDto &&
                    item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                    item.activityItemInfoDto.activityInfoDto.realStartTime > now
                "
              >
                {{ dateFormat2(item.activityItemInfoDto.activityInfoDto.realStartTime) }}开拍
              </p>
              <p v-else>
                <freeCountdown
                  v-if="
                    isRefresh &&
                      item.remainTime &&
                      item.freePrice !== 0 &&
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.auctionDto &&
                      item.activityItemInfoDto.auctionDto.reducePriceAuction &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                      item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                      now > item.activityItemInfoDto.activityInfoDto.realStartTime
                  "
                  class="time-countdown"
                  :backgroundColor="''"
                  :color="
                    item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityInfoDto &&
                    item.activityItemInfoDto.activityInfoDto.realStartTime > now
                      ? '#ff6723'
                      : '#C6001F'
                  "
                  :splitorColor="
                    item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityInfoDto &&
                    item.activityItemInfoDto.activityInfoDto.realStartTime > now
                      ? '#ff6723'
                      : '#C6001F'
                  "
                  :showColon="false"
                  @timeup="overFree"
                  :activityStatus="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityStatus
                  "
                  :actStartTime="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime
                  "
                  :actEndTime="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realEndTime
                  "
                  :second="item.remainTime"
                />
                <span
                  v-else-if="
                    item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityStatus == 2
                  "
                >
                  活动已结束</span
                >
                <span v-else class="activity-end"> 已降至最低成交价</span>
              </p>
            </div>
            <!-- 增价拍活动开始时间 -->
            <div class="activity-time" v-else>
              <p v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                {{ dateFormat2(item.activityItemInfoDto.activityInfoDto.realStartTime) }}开拍
              </p>
              <p v-else>
                <CountDown
                  v-if="
                    item.activityItemInfoDto.activityInfoDto.activityStatus === 1
                      ? item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? item.activityItemInfoDto.activityInfoDto.realStartTime
                        : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                        ? item.activityItemInfoDto.activityInfoDto.realEndTime
                        : ''
                      : ''
                  "
                  :endTime="
                    item.activityItemInfoDto.activityInfoDto.realStartTime > now
                      ? item.activityItemInfoDto.activityInfoDto.realStartTime
                      : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                      ? item.activityItemInfoDto.activityInfoDto.realEndTime
                      : ''
                  "
                  :text="
                    item.activityItemInfoDto.activityInfoDto.realStartTime > now
                      ? '距离开始还有'
                      : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                      ? '距离结束还有'
                      : '活动已结束'
                  "
                  @timeEnd="handleCountDown"
                />
                <span v-else class="activity-end">活动已结束</span>
              </p>
            </div>
            <!-- 主图 -->
            <div class="img">
              <img :src="item.mainImage" alt="" />
            </div>
            <!-- 广告语 -->
            <div class="desc-list">
              <div
                class="description"
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityInfoDto &&
                    item.activityItemInfoDto.activityInfoDto.activityDesc
                "
              >
                <span class="advertise-li"></span>
                <p>{{ item.activityItemInfoDto.activityInfoDto.activityDesc }}</p>
              </div>
            </div>
            <!-- 降价底部信息 -->
            <div
              class="content-bottom"
              v-if="
                item.activityItemInfoDto &&
                  item.activityItemInfoDto.auctionDto &&
                  item.activityItemInfoDto.auctionDto.reducePriceAuction
              "
            >
              <template v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                <div class="price">
                  <div class="price-top">
                    <img class="selection-img" :src="greyPai" mode="aspectFit" />
                    <p>起拍价</p>
                  </div>
                  <div class="price-bottom">
                    ￥{{ item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.startPrice / 100 || 0 }}
                  </div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                    <p>围观人数</p>
                  </div>
                  <div class="number-bottom">
                    {{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="price">
                  <div class="price-top">
                    <!-- 已结束 -->
                    <img
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                          item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                      "
                      class="selection-img"
                      :src="greyPai"
                      mode="aspectFit"
                    />
                    <!-- 未结束 -->
                    <img
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                          item.activityItemInfoDto.auctionDto.orderFlag
                      "
                      class="selection-img"
                      :src="redPai"
                      mode="aspectFit"
                    />
                    <!-- <p>{{ item.activityItemInfoDto.activityInfoDto.realEndTime > now ? '当前价' : '成交价' }}</p> -->
                    <!-- <p class="txt" v-if="item.activityItemInfoDto">
                      {{
                        item.activityItemInfoDto.activityInfoDto &&
                        now > item.activityItemInfoDto.activityInfoDto.realStartTime &&
                        item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                        !item.activityItemInfoDto.auctionDto.orderFlag
                          ? ''
                          : item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                          ? '成交价'
                          : '当前价'
                      }}
                    </p> -->
                    <p
                      class="txt"
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                          item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                      "
                    >
                      当前价
                    </p>
                    <p
                      class="txt"
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                          item.activityItemInfoDto.auctionDto.orderFlag
                      "
                    >
                      成交价
                    </p>
                  </div>
                  <div class="price-bottom">
                    <span
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                          item.activityItemInfoDto.activityInfoDto.realStartTime < now
                      "
                      >¥{{ item.freePrice.toFixed(2) }}
                    </span>
                    <span
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                          item.activityItemInfoDto.auctionDto.orderFlag
                      "
                      >¥{{ item.activityItemInfoDto.auctionDto.currentPrice / 100 }}
                    </span>
                    <!-- ￥{{
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? item.activityItemInfoDto &&
                          item.activityItemInfoDto &&
                          item.activityItemInfoDto.auctionDto &&
                          item.activityItemInfoDto.auctionDto.rpAuctionRuleDto &&
                          item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.startPrice / 100
                        : item.freePrice.toFixed(2)
                    }} -->
                  </div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                    <p>围观人数</p>
                  </div>
                  <div class="number-price">
                    {{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}
                  </div>
                </div>
              </template>
              <div class="btn"><div class="grounp-btn" @click="adRoute(item)">查看详情</div></div>
            </div>
            <!-- 增价底部信息 -->
            <div class="content-bottom" v-else>
              <template v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                <div class="price">
                  <div class="price-top">
                    <img class="selection-img" :src="greyPai" mode="aspectFit" />
                    <p>起拍价</p>
                  </div>
                  <div class="price-bottom"><span class='priceFlag'>￥</span>{{ item.activityItemInfoDto.auctionDto.startPrice / 100 }}</div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                    <p>围观人数</p>
                  </div>
                  <div class="number-bottom">{{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}</div>
                </div>
              </template>
              <template v-else>
                <div class="price">
                  <div class="price-top">
                    <!-- 已结束 -->
                    <img
                      v-if="
                        item.activityItemInfoDto.activityInfoDto &&
                          item.activityItemInfoDto.activityInfoDto.realEndTime < now
                      "
                      class="selection-img"
                      :src="greyPai"
                      mode="aspectFit"
                    />
                    <!-- 未结束 -->
                    <img v-else class="selection-img" :src="redPai" mode="aspectFit" />
                    <p>{{ item.activityItemInfoDto.activityInfoDto.realEndTime > now ? '当前竞价' : '成交价' }}</p>
                  </div>
                  <div class="price-bottom"><span class='priceFlag'>￥</span>{{ item.activityItemInfoDto.auctionDto.currentPrice / 100 }}</div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img
                      v-if="item.activityItemInfoDto.activityInfoDto.realEndTime < now"
                      class="selection-img"
                      :src="greyPerson"
                      mode="aspectFit"
                    />
                    <img v-else class="selection-img" :src="redPerson" mode="aspectFit" />
                    <p>出价次数</p>
                  </div>
                  <div class="number-price">{{ item.activityItemInfoDto.auctionDto.bidCount || 0 }}</div>
                </div>
              </template>
              <div class="btn"><div class="grounp-btn" @click="adRoute(item)">查看详情</div></div>
            </div>
          </div>
          <div class="onlyProductImage" v-else>
            <img class="selection-img" :src="item.mainImage" mode="aspectFit" />
          </div>
        </div>
      </template>

      <!-- 样式二 -->
      <template v-if="styleTwo">
        <div class="groupList-two" v-for="item in listTwo" :key="item.id" @click="adRoute(item)">
          <div class="Deposit">
            <span>拍卖</span>
          </div>
          <div v-if="item.id" class="group-info">
            <!-- 左边部分 -->
            <div class="content-left">
              <!-- 主图 -->
              <div class="img-main">
                <img :src="item.mainImage" alt="" />
              </div>
              <!-- 降价竞拍信息 -->
              <div
                class="left-bottom"
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.auctionDto &&
                    item.activityItemInfoDto.auctionDto.reducePriceAuction
                "
              >
                <template v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                  <div class="price">
                    <div class="price-top">
                      <img class="selection-img" :src="greyPai" mode="aspectFit" />
                      <p>起拍价</p>
                    </div>
                    <div class="price-bottom">
                      ￥{{ item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.startPrice / 100 || 0 }}
                    </div>
                  </div>
                  <div class="number">
                    <div class="number-top">
                      <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                      <p>围观人数</p>
                    </div>
                    <div class="number-bottom">
                      {{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="price">
                    <div class="price-top">
                      <!-- 已结束 -->
                      <img
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                        "
                        class="selection-img"
                        :src="greyPai"
                        mode="aspectFit"
                      />
                      <!-- 未结束 -->
                      <img
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                        "
                        class="selection-img"
                        :src="redPai"
                        mode="aspectFit"
                      />
                      <!-- <p>{{ item.activityItemInfoDto.activityInfoDto.realEndTime > now ? '当前价' : '成交价' }}</p> -->
                      <!-- <p class="txt" v-if="item.activityItemInfoDto">
                        {{
                          item.activityItemInfoDto.activityInfoDto &&
                          now > item.activityItemInfoDto.activityInfoDto.realStartTime &&
                          item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                          !item.activityItemInfoDto.auctionDto.orderFlag
                            ? ''
                            : item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                              item.activityItemInfoDto.auctionDto.orderFlag
                            ? '成交价'
                            : '当前价'
                        }}
                      </p> -->
                      <p
                        class="txt"
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                        "
                      >
                        当前价
                      </p>
                      <p
                        class="txt"
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                        "
                      >
                        成交价
                      </p>
                    </div>
                    <div class="price-bottom">
                      <span
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                            item.activityItemInfoDto.activityInfoDto.realStartTime < now
                        "
                        >¥{{ item.freePrice.toFixed(2) }}
                      </span>
                      <span
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                        "
                        >¥{{ item.activityItemInfoDto.auctionDto.currentPrice / 100 }}
                      </span>
                      <!-- ￥{{
                        item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realStartTime > now
                          ? item.activityItemInfoDto &&
                            item.activityItemInfoDto &&
                            item.activityItemInfoDto.auctionDto &&
                            item.activityItemInfoDto.auctionDto.rpAuctionRuleDto &&
                            item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.startPrice / 100
                          : item.freePrice.toFixed(2)
                      }} -->
                    </div>
                  </div>
                  <div class="number">
                    <div class="number-top">
                      <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                      <p>围观人数</p>
                    </div>
                    <div class="number-price">
                      {{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}
                    </div>
                  </div>
                </template>
              </div>
              <!-- 增价竞拍信息 -->
              <div class="left-bottom" v-else>
                <template v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                  <div class="price">
                    <div class="price-top">
                      <img class="selection-img" :src="greyPai" mode="aspectFit" />
                      <p>起拍价</p>
                    </div>
                    <div class="price-bottom"><span class='priceFlag'>￥</span>{{ item.activityItemInfoDto.auctionDto.startPrice / 100 }}</div>
                  </div>
                  <div class="number">
                    <div class="number-top">
                      <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                      <p>围观人数</p>
                    </div>
                    <div class="number-bottom">{{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}</div>
                  </div>
                </template>
                <template v-else>
                  <div class="price">
                    <div class="price-top">
                      <!-- 已结束 -->
                      <img
                        v-if="item.activityItemInfoDto.activityInfoDto.realEndTime < now"
                        class="selection-img"
                        :src="greyPai"
                        mode="aspectFit"
                      />
                      <!-- 未结束 -->
                      <img v-else class="selection-img" :src="redPai" mode="aspectFit" />
                      <p>{{ item.activityItemInfoDto.activityInfoDto.realEndTime > now ? '当前竞价' : '成交价' }}</p>
                    </div>
                    <div class="price-bottom"><span class='priceFlag'>￥</span>{{ item.activityItemInfoDto.auctionDto.currentPrice / 100 }}</div>
                  </div>
                  <div class="number">
                    <div class="number-top">
                      <img
                        v-if="item.activityItemInfoDto.activityInfoDto.realEndTime < now"
                        class="selection-img"
                        :src="greyPerson"
                        mode="aspectFit"
                      />
                      <img v-else class="selection-img" :src="redPerson" mode="aspectFit" />
                      <p>出价次数</p>
                    </div>
                    <div class="number-price">{{ item.activityItemInfoDto.auctionDto.bidCount || 0 }}</div>
                  </div>
                </template>
              </div>
            </div>
            <!-- 右边部分 -->
            <div class="content-right">
              <!-- 标题 -->
              <div class="name-wrap">
                <div class="groupName">
                  {{ item.name }}
                </div>
                <!-- sku -->
                <div
                  class="goods-sku"
                  v-if="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityItemDtoList &&
                      item.activityItemInfoDto.activityItemDtoList[0] &&
                      item.activityItemInfoDto.activityItemDtoList[0].itemExtDto &&
                      item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes &&
                      item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes.length
                  "
                >
                  <div
                    class="goods-sku-item"
                    v-for="(attr, attrIndex) in item.activityItemInfoDto.activityItemDtoList[0].itemExtDto
                      .saleAttributes"
                    :key="attrIndex"
                  >
                    {{ attr.attrVal }}
                  </div>
                </div>
              </div>
              <!-- 降价活动开始时间 -->
              <div
                class="activity-time"
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.auctionDto &&
                    item.activityItemInfoDto.auctionDto.reducePriceAuction
                "
              >
                <p
                  v-if="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                  "
                >
                  {{ dateFormat2(item.activityItemInfoDto.activityInfoDto.realStartTime) }}开拍
                </p>
                <p v-else>
                  <freeCountdown
                    v-if="
                      isRefresh &&
                        item.remainTime &&
                        item.freePrice !== 0 &&
                        item.activityItemInfoDto &&
                        item.activityItemInfoDto.auctionDto &&
                        item.activityItemInfoDto.auctionDto.reducePriceAuction &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                        item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                        now > item.activityItemInfoDto.activityInfoDto.realStartTime
                    "
                    class="time-countdown"
                    :backgroundColor="''"
                    :color="
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? '#ff6723'
                        : '#C6001F'
                    "
                    :splitorColor="
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? '#ff6723'
                        : '#C6001F'
                    "
                    :showColon="false"
                    @timeup="overFree"
                    :activityStatus="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.activityStatus
                    "
                    :actStartTime="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realStartTime
                    "
                    :actEndTime="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realEndTime
                    "
                    :second="item.remainTime"
                  />
                  <span v-else-if="item.activityItemInfoDto.activityInfoDto.activityStatus == 2"> 活动已结束</span>
                  <span v-else class="activity-end"> 已降至最低成交价</span>
                </p>
              </div>
              <!--增价活动开始时间 -->
              <div class="activity-time" v-else>
                <p v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                  {{ dateFormat2(item.activityItemInfoDto.activityInfoDto.realStartTime) }}开拍
                </p>
                <p v-else>
                  <CountDown
                    v-if="
                      item.activityItemInfoDto.activityInfoDto.activityStatus === 1
                        ? item.activityItemInfoDto.activityInfoDto.realStartTime > now
                          ? item.activityItemInfoDto.activityInfoDto.realStartTime
                          : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                          ? item.activityItemInfoDto.activityInfoDto.realEndTime
                          : ''
                        : ''
                    "
                    :endTime="
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? item.activityItemInfoDto.activityInfoDto.realStartTime
                        : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                        ? item.activityItemInfoDto.activityInfoDto.realEndTime
                        : ''
                    "
                    :text="
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? '距离开始还有'
                        : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                        ? '距离结束还有'
                        : '活动已结束'
                    "
                    @timeEnd="handleCountDown"
                  />
                  <span v-else class="activity-end">活动已结束</span>
                </p>
              </div>

              <!-- 广告语 -->
              <div class="desc-list">
                <div
                  class="description"
                  v-if="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityDesc
                  "
                >
                  <span class="advertise-li"></span>
                  <p>{{ item.activityItemInfoDto.activityInfoDto.activityDesc }}</p>
                </div>
              </div>
              <!-- 底部信息 -->
              <div class="content-bottom">
                <div class="btn"><div class="grounp-btn" @click="adRoute(item)">查看详情</div></div>
              </div>
            </div>
          </div>
          <div class="onlyProductImage" v-else>
            <img class="selection-img" :src="item.mainImage" mode="aspectFit" />
          </div>
        </div>
      </template>

      <!-- 样式三 -->
      <template v-if="styleThree">
        <div class="groupList-three" v-for="item in listThree" :key="item.id" @click="adRoute(item)">
          <div class="Deposit">
            <span>拍卖</span>
          </div>
          <div v-if="item.id" class="group-info">
            <!-- 主图部分 -->
            <div class="img-main">
              <img :src="item.mainImage" alt="" />
            </div>
            <!-- 产品信息 -->
            <div class="prod-info">
              <!-- 标题 -->
              <p class="groupName">
                {{ item.name }}
              </p>
              <!-- 活动开始时间 -->
              <div
                class="activity-time"
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.auctionDto &&
                    item.activityItemInfoDto.auctionDto.reducePriceAuction
                "
              >
                <p
                  v-if="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                  "
                >
                  {{ dateFormat2(item.activityItemInfoDto.activityInfoDto.realStartTime) }}开拍
                </p>
                <p v-else>
                  <freeCountdown
                    v-if="
                      isRefresh &&
                        item.remainTime &&
                        item.freePrice !== 0 &&
                        item.activityItemInfoDto &&
                        item.activityItemInfoDto.auctionDto &&
                        item.activityItemInfoDto.auctionDto.reducePriceAuction &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                        item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                        now > item.activityItemInfoDto.activityInfoDto.realStartTime
                    "
                    class="time-countdown"
                    :backgroundColor="''"
                    :color="
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? '#ff6723'
                        : '#C6001F'
                    "
                    :splitorColor="
                      item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? '#ff6723'
                        : '#C6001F'
                    "
                    :showColon="false"
                    @timeup="overFree"
                    :activityStatus="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.activityStatus
                    "
                    :actStartTime="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realStartTime
                    "
                    :actEndTime="
                      item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realEndTime
                    "
                    :second="item.remainTime"
                  />
                  <span v-else-if="item.activityItemInfoDto.activityInfoDto.activityStatus == 2"> 活动已结束</span>
                  <span v-else class="activity-end"> 已降至最低成交价</span>
                </p>
              </div>
              <!-- 活动开始时间 -->
              <div class="activity-time" v-else>
                <p v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                  {{ dateFormat2(item.activityItemInfoDto.activityInfoDto.realStartTime) }}开拍
                </p>
                <p v-else>
                  <CountDown
                    v-if="
                      item.activityItemInfoDto.activityInfoDto.activityStatus === 1
                        ? item.activityItemInfoDto.activityInfoDto.realStartTime > now
                          ? item.activityItemInfoDto.activityInfoDto.realStartTime
                          : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                          ? item.activityItemInfoDto.activityInfoDto.realEndTime
                          : ''
                        : ''
                    "
                    :endTime="
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? item.activityItemInfoDto.activityInfoDto.realStartTime
                        : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                        ? item.activityItemInfoDto.activityInfoDto.realEndTime
                        : ''
                    "
                    :text="
                      item.activityItemInfoDto.activityInfoDto.realStartTime > now
                        ? '距离开始还有'
                        : item.activityItemInfoDto.activityInfoDto.realEndTime > now
                        ? '距离结束还有'
                        : '活动已结束'
                    "
                    @timeEnd="handleCountDown"
                  />
                  <span v-else class="activity-end">活动已结束</span>
                </p>
              </div>
              <!-- sku -->
              <div
                class="goods-sku"
                v-if="
                  item.activityItemInfoDto &&
                    item.activityItemInfoDto.activityItemDtoList &&
                    item.activityItemInfoDto.activityItemDtoList[0] &&
                    item.activityItemInfoDto.activityItemDtoList[0].itemExtDto &&
                    item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes &&
                    item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes.length
                "
              >
                <div
                  class="goods-sku-item"
                  v-for="(attr, attrIndex) in item.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes"
                  :key="attrIndex"
                >
                  {{ attr.attrVal }}
                </div>
              </div>
              <!-- 广告语 -->
              <div class="desc-list">
                <div
                  class="description"
                  v-if="
                    item.activityItemInfoDto &&
                      item.activityItemInfoDto.activityInfoDto &&
                      item.activityItemInfoDto.activityInfoDto.activityDesc
                  "
                >
                  <span class="advertise-li"></span>
                  <p>{{ item.activityItemInfoDto.activityInfoDto.activityDesc }}</p>
                </div>
              </div>
            </div>
            <!--  降价拍 -->
            <template
              v-if="
                item.activityItemInfoDto &&
                  item.activityItemInfoDto.auctionDto &&
                  item.activityItemInfoDto.auctionDto.reducePriceAuction
              "
            >
              <template v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                <div class="price">
                  <div class="price-content">
                    <div class="price-top">
                      <img class="selection-img" :src="greyPai" mode="aspectFit" />
                      <p>起拍价</p>
                    </div>
                    <div class="price-bottom">
                      ￥{{ item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.startPrice / 100 }}
                    </div>
                  </div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                    <p>围观人数</p>
                  </div>
                  <div class="number-bottom">
                    {{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="price">
                  <div class="price-content">
                    <div class="price-top">
                      <!-- 已结束 -->
                      <img
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                        "
                        class="selection-img"
                        :src="greyPai"
                        mode="aspectFit"
                      />
                      <!-- 未结束 -->
                      <img
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                        "
                        class="selection-img"
                        :src="redPai"
                        mode="aspectFit"
                      />
                      <!-- <p>{{ item.activityItemInfoDto.activityInfoDto.realEndTime > now ? '当前价' : '成交价' }}</p> -->
                      <!-- <p class="txt" v-if="item.activityItemInfoDto">
                        {{
                          item.activityItemInfoDto.activityInfoDto &&
                          now > item.activityItemInfoDto.activityInfoDto.realStartTime &&
                          item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                          !item.activityItemInfoDto.auctionDto.orderFlag
                            ? ''
                            : item.activityItemInfoDto.activityInfoDto.realEndTime > now &&
                              item.activityItemInfoDto.auctionDto.orderFlag
                            ? '成交价'
                            : '当前价'
                        }}
                      </p> -->
                      <p
                        class="txt"
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.realStartTime < now &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus !== 2
                        "
                      >
                        当前价
                      </p>
                      <p
                        class="txt"
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                        "
                      >
                        成交价
                      </p>
                    </div>
                    <div class="price-bottom">
                      <span
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus !== 2 &&
                            item.activityItemInfoDto.activityInfoDto.realStartTime < now
                        "
                        >¥{{ item.freePrice.toFixed(2) }}
                      </span>
                      <span
                        v-if="
                          item.activityItemInfoDto.activityInfoDto &&
                            item.activityItemInfoDto.activityInfoDto.activityStatus === 2 &&
                            item.activityItemInfoDto.auctionDto.orderFlag
                        "
                        >¥{{ item.activityItemInfoDto.auctionDto.currentPrice / 100 }}
                      </span>
                      <!-- ￥{{
                        item.activityItemInfoDto &&
                        item.activityItemInfoDto.activityInfoDto &&
                        item.activityItemInfoDto.activityInfoDto.realStartTime > now
                          ? item.activityItemInfoDto &&
                            item.activityItemInfoDto.auctionDto &&
                            item.activityItemInfoDto.auctionDto.rpAuctionRuleDto &&
                            item.activityItemInfoDto.auctionDto.rpAuctionRuleDto.startPrice / 100
                          : item.freePrice.toFixed(2)
                      }} -->
                    </div>
                  </div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                    <p>围观人数</p>
                  </div>
                  <div class="number-price">
                    {{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}
                  </div>
                </div>
              </template>
            </template>
            <!--  增价拍 -->
            <template v-else>
              <template v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime">
                <div class="price">
                  <div class="price-content">
                    <div class="price-top">
                      <img class="selection-img" :src="greyPai" mode="aspectFit" />
                      <p>起拍价</p>
                    </div>
                    <div class="price-bottom"><span class='priceFlag'>￥</span>{{ item.activityItemInfoDto.auctionDto.startPrice / 100 }}</div>
                  </div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img class="selection-img" :src="greyPerson" mode="aspectFit" />
                    <p>围观人数</p>
                  </div>
                  <div class="number-bottom">{{ item.activityItemInfoDto.auctionDto.watchCount || 0 }}</div>
                </div>
              </template>
              <template v-else>
                <div class="price">
                  <div class="price-content">
                    <div class="price-top">
                      <!-- 已结束 -->
                      <img
                        v-if="item.activityItemInfoDto.activityInfoDto.realEndTime < now"
                        class="selection-img"
                        :src="greyPai"
                        mode="aspectFit"
                      />
                      <!-- 未结束 -->
                      <img v-else class="selection-img" :src="redPai" mode="aspectFit" />
                      <p>{{ item.activityItemInfoDto.activityInfoDto.realEndTime > now ? '当前竞价' : '成交价' }}</p>
                    </div>
                    <div class="price-bottom"><span class='priceFlag'>￥</span>{{ item.activityItemInfoDto.auctionDto.currentPrice / 100 }}</div>
                  </div>
                </div>
                <div class="number">
                  <div class="number-top">
                    <img
                      v-if="item.activityItemInfoDto.activityInfoDto.realEndTime < now"
                      class="selection-img"
                      :src="greyPerson"
                      mode="aspectFit"
                    />
                    <img class="selection-img" :src="redPerson" mode="aspectFit" />
                    <p>出价次数</p>
                  </div>
                  <div class="number-price">{{ item.activityItemInfoDto.auctionDto.bidCount || 0 }}</div>
                </div>
              </template>
            </template>

            <!-- 立即参与按钮 -->
            <div class="btn"><div class="grounp-btn" @click="adRoute(item)">查看详情</div></div>
          </div>
          <div class="onlyProductImage" v-else>
            <img class="selection-img" :src="item.mainImage" mode="aspectFit" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CountDown from '@/components/common/CountDown'
import redPai from '../../../assets/images/activity/auction/red-pai.png'
import greyPai from '../../../assets/images/activity/auction/grey-pai.png'
import redPerson from '../../../assets/images/activity/auction/red-person.png'
import greyPerson from '../../../assets/images/activity/auction/grey-person.png'
import baseLayout from '@/mixins/baseLayout.vue'
import freeCountdown from '@/components/common/freeFall-count' // freeFall-count

export default {
  name: 'auction',
  mixins: [baseLayout],
  data() {
    return {
      redPai,
      greyPai,
      redPerson,
      greyPerson,
      groCarList: [],
      now: '',
      carList: [],
      listOne: [],
      listTwo: [],
      listThree: [],
      styleOne: true,
      styleTwo: false,
      styleThree: false,
      reducePriceAuction: false,
      isRefresh: true,
      list: [],
      isFreeFall: false // 是否降价拍
    }
  },
  props: {
    groupCarList: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      title: '整车拍卖'
    }
  },
  components: { CountDown, freeCountdown },
  computed: {
    // 获取结束时间
    getAutionEnd(item) {
      return item.activityItemInfoDto.activityInfoDto.realEndTime > this.now
    }
  },
  methods: {
    handleCountDown() {
      // this.reload()
      this.filterActivity()
    },
    overFree() {
      this.isRefresh = false
      this.$nextTick(() => {
        this.isRefresh = true
      })
      this.groupCarList.itemList.map((item, i) => {
        this.carList[i] = item
        this.$set(this.carList[i], 'freePrice', this.getFreeFall(this.carList[i], 1))
        this.$set(this.carList[i], 'remainTime', this.getFreeFall(this.carList[i], 0))
      })
    },
    filterActivity() {
      this.groupCarList.itemList.map((res) => {
        if (res.activityItemInfoDto && res.activityItemInfoDto.activityInfoDto && res.activityItemInfoDto.auctionDto) {
          if (
            res.activityItemInfoDto &&
            res.activityItemInfoDto.activityInfoDto &&
            res.activityItemInfoDto.auctionDto &&
            res.activityItemInfoDto.auctionDto.reducePriceAuction
          ) {
            this.$set(res, 'freePrice', this.getFreeFall(res, 1))
            this.$set(res, 'remainTime', this.getFreeFall(res, 0))
          }
          this.carList.push(res)
        }
      })
      this.carList.map((res) => {
        if (
          res.activityItemInfoDto &&
          res.activityItemInfoDto.activityItemDtoList[0] &&
          res.activityItemInfoDto.activityItemDtoList[0].itemExtDto &&
          res.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes
        ) {
          res.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes = JSON.parse(
            res.activityItemInfoDto.activityItemDtoList[0].itemExtDto.saleAttributes
          )
        }
      })
      this.selectStyle()
    },
    dateFormat2(date) {
      if (!date) return ''
      return moment(date).format('MM月DD日 HH:mm')
    },
    // 点击进入详情页
    adRoute(item) {
      let url = ''
      if (item.type === '0' || item.type === 0) {
        if (
          item.activityItemInfoDto &&
          item.activityItemInfoDto.activityInfoDto &&
          item.activityItemInfoDto.activityInfoDto.id
        ) {
          url = `/details/allCars?activityId=${item.activityItemInfoDto.activityInfoDto.id}&id=${item.id}`
        } else {
          url = `/details/allCars?id=${item.id}`
        }
      } else {
        if (
          item.activityItemInfoDto &&
          item.activityItemInfoDto.activityInfoDto &&
          item.activityItemInfoDto.activityInfoDto.id
        ) {
          url = `/details/boutiqueAccessories?activityId=${item.activityItemInfoDto.activityInfoDto.id}&id=${item.id}`
        } else {
          url = `/details/boutiqueAccessories?id=${item.id}`
        }
      }
      this.$router.push(url)
    },
    // 判断当前的遍历格式
    selectStyle() {
      if (this.carList.length === 1) {
        this.styleThree = true
        this.styleOne = false
        this.styleTwo = false
        this.listThree = this.carList
      }
      if (this.carList.length === 2) {
        this.styleThree = false
        this.styleOne = false
        this.styleTwo = true
        this.listTwo = this.carList
      }
      if (this.carList.length === 3) {
        this.styleThree = false
        this.styleOne = true
        this.styleTwo = false
        this.listOne = this.carList
      }
      if (this.carList.length > 3) {
        let remainder = this.carList.length % 3
        switch (remainder) {
          case 0:
            this.styleThree = false
            this.styleOne = true
            this.styleTwo = false
            this.listOne = this.carList
            break
          case 1:
            this.styleThree = true
            this.styleOne = true
            this.styleTwo = false
            this.carList.forEach((item, index) => {
              if (index < this.carList.length - 1) {
                this.listOne.push(item)
              } else {
                this.listThree.push(item)
              }
            })
            break
          case 2:
            this.styleThree = false
            this.styleOne = true
            this.styleTwo = true
            this.carList.forEach((item, index) => {
              if (index < this.carList.length - 2) {
                this.listOne.push(item)
              } else {
                this.listTwo.push(item)
              }
            })
            break
        }
      }
    },
    getFreeFall(item, type) {
      // 活动信息
      let activityInfo =
        item &&
        item.activityItemInfoDto &&
        item.activityItemInfoDto.activityInfoDto &&
        item.activityItemInfoDto.activityInfoDto

      // 降价拍信息
      let rpAuctionRuleDto =
        item &&
        item.activityItemInfoDto &&
        item.activityItemInfoDto.auctionDto &&
        item.activityItemInfoDto.auctionDto.rpAuctionRuleDto // 降价拍规则拓展字段

      let cutStartTime = activityInfo && activityInfo.realStartTime // 活动开始时间

      let currentTime = new Date().getTime() // 当前时间
      let i = rpAuctionRuleDto && rpAuctionRuleDto.interval // 时间片（分钟）
      let s = (currentTime - cutStartTime) / (i * 60 * 1000)
      let T = Math.floor(s) // 已降价次数
      let cutStartPrice = rpAuctionRuleDto && rpAuctionRuleDto.startPrice // 起拍价
      let lowestPrice = rpAuctionRuleDto && rpAuctionRuleDto.lowestPrice // 最低价
      let range = rpAuctionRuleDto && rpAuctionRuleDto.reduceStep / 100 // 降价幅度
      let cutPrice // 当前价
      if (cutStartPrice - T * range <= lowestPrice) {
        cutPrice = lowestPrice
      } else {
        let price = cutStartPrice - T * range * 100 // 降价拍当前价
        cutPrice = price && price > lowestPrice ? price : lowestPrice
      }
      let T2 = (currentTime - cutStartTime) % (i * 60 * 1000) // 当前区间（时间片）已经过去的时间
      let residueTime = i * 60 * 1000 - T2 > 0 ? i * 60 * 1000 - T2 : i * 60 * 1000 // 剩余时间（距离下次降价剩余时间）
      if (type === 1) {
        return cutPrice / 100 // 降价拍当前价
      } else if (type === 0 && cutPrice - lowestPrice >= lowestPrice && residueTime >= 0) {
        return residueTime / 1000 // 剩余时间（距离下次降价剩余时间:秒）
      }
    }
  },
  /* eslint-disable */
  created() {
    this.now = Date.parse(new Date())
    this.filterActivity()
  }
}
</script>

<style lang="scss" scoped>
.right {
  padding-right: 40px;
  display: flex;
  font-size: 14px;
  span {
    margin-left: 3px;
  }
}
.Deposit {
  width: 66px;
  height: 66px;
  position: absolute;
  top: 0px;
  right: -6px;
  background-image: url('../../../assets/flag.png');
  background-repeat: no-repeat;
  > span {
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 14px;
    display: inline-block;
    transform: translateX(25px) translateY(15px) rotate(45deg);
  }
}
.onlyProductImage {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: auto;
    height: 138px;
  }
}
.date-red {
  color: #c6001f;
  margin-right: 4px;
}
.person-red {
  color: #c6001f;
  margin-right: 4px;
}
.content-bottom {
  width: 100%;
  // height: 102px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .price {
    .price-top {
      display: flex;
      align-items: center;
      .selection-img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
      p {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }
    .price-bottom {
      font-size: 28px;
      font-weight: 500;
      color: #c6001f;
      line-height: 20px;
      margin-top:5px;
      .priceFlag{
        font-size:18px;
      }
    }
  }
  .number {
    .number-top {
      display: flex;
      align-items: center;
      .selection-img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
      p {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }
    .number-bottom {
      padding-left: 3px;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 20px;
    }
    .number-price {
      color: #000000;
      padding-left: 3px;
      font-size: 28px;
      font-weight: 500;
      line-height: 20px;
      margin-top:5px;
    }
  }
  .group-num {
    font-size: 14px;
    font-weight: 400;
    color: #6c6c6c;
    line-height: 20px;
  }
  .grounp-btn {
    box-sizing: border-box;
    width: 88px;
    height: 36px;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    border: 1px solid #999;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background: #c6001f;
      color: #fff;
    }
  }
}
.groupMain {
  margin: 0 auto;
  width: 1360px;
  .title {
    width: 100%;
    font-size: 30px;
    font-family: 'NotoSansHans-Bold';
    font-weight: bold;
    margin-bottom: 25px;
    padding-top: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}

.groupCar {
  width: 1360px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  .groupList {
    box-sizing: border-box;
    width: 443px;
    min-height: 350px;
    padding: 26px 36px 20px;
    background: rgba(255, 255, 255, 1);
    transition: all 0.2s linear;
    position: relative;
    margin-right: 15px;
    margin-bottom: 15px;
    .group-info:hover {
      cursor: pointer;
    }

    .desc-list {
      width: 100%;
      margin: 10px 0 10px 0;
      min-height: 44px;
      .description {
        display: flex;
        width: 100%;
        height: 20px;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        .advertise-li {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #c6001f;
          border-radius: 4px;
          margin-right: 6px;
        }
      }
    }
    .activity-time {
      margin-top: 4px;
      height: 20px;
      font-size: 14px;
      color: #c6001f;
      line-height: 20px;
      .activity-end {
        color: #bdbdbd;
      }
    }
    .name-wrap {
      display: flex;
      align-items: flex-end;
    }
    .groupName {
      margin-right: 10px;
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      span {
        display: inline-block;
        height: 23px;
        line-height: 23px;
        padding: 0 4px;
        background: rgba(218, 30, 70, 1);
        border-radius: 2px;
        color: #fff;
        font-size: 13px;
        text-align: center;
        margin-right: 12px;
      }
    }
    .goods-sku {
      display: flex;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      .goods-sku-item {
        max-width: 200px;
        margin-right: 10px;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .groupList:hover {
    // top: -3px;
    // box-shadow: 0px 4px 10px 0px rgb(27 50 71 / 22%);
  }
  .groupList:nth-of-type(3n) {
    margin-right: 0;
  }
  // .groupList:hover {
  //   top: -3px;
  //   box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
  // }
  .groupList-two {
    box-sizing: border-box;
    width: 672px;
    min-height: 272px;
    padding: 26px 36px 20px;
    background: rgba(255, 255, 255, 1);
    transition: all 0.2s linear;
    position: relative;
    margin-right: 15px;
    margin-bottom: 15px;
    .group-info {
      width: 100%;
      height: 100%;
      display: flex;
    }
    .group-info:hover {
      cursor: pointer;
    }
    .content-left {
      width: 343px;
      height: 100%;
      .img-main {
        width: 245px;
        height: 138px;
        top: 51px;
        margin: 9px 0;
        margin-left: 44px;
        img {
          width: auto;
          height: 100%;
        }
      }
      .left-bottom {
        margin-top: 20px;
        margin-left: 44px;
        display: flex;
        .price {
          margin-right: 65px;
          .price-top {
            display: flex;
            align-items: center;
            .selection-img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }
            p {
              font-size: 14px;
              color: #666666;
              line-height: 20px;
            }
          }
          .price-bottom {
            font-size: 28px;
            font-weight: 500;
            color: #c6001f;
            line-height: 20px;
            margin-top:5px;
            .priceFlag{
              font-size:18px;
            }
          }
        }
        .number {
          .number-top {
            display: flex;
            align-items: center;
            .selection-img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }
            p {
              font-size: 14px;
              color: #666666;
              line-height: 20px;
            }
          }
          .number-bottom {
            padding-left: 3px;
            font-size: 14px;
            font-weight: 500;
            color: #666666;
            line-height: 20px;
          }
          .number-price {
            color: #000000;
            padding-left: 3px;
            font-size: 28px;
            font-weight: 500;
            line-height: 20px;
            margin-top:5px;
          }
        }
      }
    }
    .content-right {
      width: calc(100% - 343px);
      height: 100%;
    }
    .desc-list {
      width: 100%;
      margin: 10px 0 10px 0;
      min-height: 44px;
      margin-top: 36px;
      margin-bottom: 40px;
      .description {
        display: flex;
        width: 100%;
        height: 20px;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        .advertise-li {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #c6001f;
          border-radius: 4px;
          margin-right: 6px;
        }
      }
    }
    .activity-time {
      margin-top: 4px;
      height: 20px;
      font-size: 14px;
      color: #c6001f;
      line-height: 20px;
    }
    .name-wrap {
      display: flex;
      align-items: flex-end;
    }
    .groupName {
      margin-right: 10px;
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      span {
        display: inline-block;
        height: 23px;
        line-height: 23px;
        padding: 0 4px;
        background: rgba(218, 30, 70, 1);
        border-radius: 2px;
        color: #fff;
        font-size: 13px;
        text-align: center;
        margin-right: 12px;
      }
    }
    .goods-sku {
      display: flex;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      .goods-sku-item {
        margin-right: 10px;
        max-width: 100px;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .groupList-two:nth-of-type(2n + 1) {
    margin-right: 0;
  }
  .groupList-two:hover {
    top: -3px;
    box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
  }

  .groupList-three {
    box-sizing: border-box;
    width: 1360px;
    min-height: 200px;
    padding: 20px 36px 20px;
    background: rgba(255, 255, 255, 1);
    transition: all 0.2s linear;
    position: relative;
    margin-bottom: 15px;
    .group-info {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .group-info:hover {
      cursor: pointer;
    }

    .img-main {
      width: 245px;
      height: 138px;
      margin-left: 44px;
      margin-right: 76px;
      img {
        width: auto;
        height: 100%;
      }
    }
    .prod-info {
      max-width: 260px;
      margin-top: 5px;
      margin-right: 60px;
      .groupName {
        width: 260px !important;
      }
    }
    .price {
      margin-top: 5px;
      width: 236px;
      margin-right: 65px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      border-left: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;
      .price-content {
        margin: 0 auto;
        .price-top {
          display: flex;
          align-items: center;
          .selection-img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }
          p {
            font-size: 14px;
            color: #666666;
            line-height: 20px;
          }
        }
        .price-bottom {
          font-size: 28px;
          font-weight: 500;
          color: #c6001f;
          line-height: 25px;
          margin-top:5px;
          .priceFlag{
            font-size:18px;
          }
        }
      }
    }
    .number {
      margin-top: 5px;
      width: 160px;
      .number-top {
        display: flex;
        align-items: center;
        .selection-img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
        p {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
        }
      }
      .number-bottom {
        padding-left: 3px;
        font-size: 18px;
        font-weight: 500;
        color: #666666;
        line-height: 25px;
      }
      .number-price {
        color: #000000;
        padding-left: 3px;
        font-size: 28px;
        font-weight: 500;
        line-height: 25px;
        margin-top:5px;
      }
    }
    .btn {
      margin-top: 5px;
      box-sizing: border-box;
      width: 138px;
      height: 44px;
      font-size: 18px;
      font-weight: 500;
      color: #c6001f;
      border: 1px solid #c6001f;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: #c6001f;
        color: #fff;
      }
    }

    .desc-list {
      width: 100%;
      margin: 10px 0 10px 0;
      min-height: 44px;
      margin-top: 18px;
      .description {
        display: flex;
        width: 100%;
        height: 20px;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        .advertise-li {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #c6001f;
          border-radius: 4px;
          margin-right: 6px;
        }
      }
    }
    .activity-time {
      margin-top: 4px;
      height: 20px;
      font-size: 14px;
      color: #c6001f;
      line-height: 20px;
    }
    .goods-sku {
      display: flex;
      justify-content: flex-start;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      max-width: 260px;
      overflow: hidden;
      word-break: keep-all;
      white-space: nowrap;
      text-overflow: ellipsis;
      .goods-sku-item {
        max-width: 200px;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 10px;
      }
    }
    .groupName {
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      line-height: 33px;
      span {
        display: inline-block;
        height: 23px;
        line-height: 23px;
        padding: 0 4px;
        background: rgba(218, 30, 70, 1);
        border-radius: 2px;
        color: #fff;
        font-size: 13px;
        text-align: center;
        margin-right: 12px;
      }
    }
  }

  .groupList-three:hover {
    top: -3px;
    box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
  }
  .img {
    width: 245px;
    height: 138px;
    top: 51px;
    margin: 9px auto;
    display: flex;
    justify-content: center;
    img {
      width: auto;
      height: 100%;
    }
  }
}
</style>
